<template>
    <div class="stake-component">
        <stake-banner :mode="mode"></stake-banner>
        <div class="uk-grid-row-collapse uk-padding-small uk-child-width-1-3@m uk-grid-match" uk-grid>
            <stake-card
                v-for="card in cards" :key="card.title"
                :mode="mode"
                :card="card">

            </stake-card>
        </div>
    </div>
</template>

<script>
import StakeBanner from '@/components/reusables/StakeBanner';
import StakeCard from '@/components/reusables/StakeCard';
import { stakes } from '@/utils/Stakes';

export default {
    name: "Stake",
    components: {
        'stake-banner': StakeBanner,
        'stake-card': StakeCard
    },
    props: {
        mode: String
    },
    data: function() {
        return {
            cards: stakes
        }
    }
}
</script>

<style lang="less" scoped>

</style>